import React, { useState } from 'react';
import { HeaderAndContentWrapper } from '../components/HeaderAndContentWrapper';
import { DropzoneAndStep } from '../components/DropzoneAndStep';

export const Migration3 = () => {
    const [percent, setPercent] = useState(0);
    const [step, setStep] = useState(4);
    const [isInsertDone, setIsInsertDone] = useState(false);
    const [isDownLoad, setIsDownLoad] = useState(false);
    const storeData = JSON.parse(sessionStorage.getItem('storeData') ?? '{}');

    const dropzoneProps = {
        changeStep: setStep,
        changePercent: setPercent,
        completion: isInsertDone,
        changeCompletion: setIsInsertDone,
        step: step,
        isDownLoad: isDownLoad
    };

    const stepPercentProps = {
        step: step,
        percent: percent,
        completion: isInsertDone,
        changeDownLoad: setIsDownLoad
    };

    return (
        <HeaderAndContentWrapper
            contents={
                <DropzoneAndStep
                    dropzoneProps = {dropzoneProps}
                    stepPercentProps = {stepPercentProps}
                />
            }
            storeName = {`${storeData.locationSi}-${storeData.name}`}
        />
    );
};
